// removed by extract-text-webpack-plugin
module.exports = {"logo-bg":"logo-bg_2BtBc","header":"header_3fP58"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.less
// module id = 24
// module chunks = 0